import {
  AdministradorCreate,
  AdministradorEdit,
  EditableAdministradorList
} from "./administradores";
import {
  CartoneroCreate,
  CartoneroEdit,
  CartoneroList,
  EditableCartoneroList,
  CartoneroShow
} from "./cartoneros";
import {
  CoordinadorCreate,
  CoordinadorEdit,
  EditableCoordinadorList
} from "./coordinadores";
import {
  PesadorCreate,
  PesadorEdit,
  PesadorList,
  EditablePesadorList,
  PesadorShow,
} from "./pesadores";
import { OperacionCreate } from "./operaciones";
import { UserProfileEdit } from "./../components/UserProfileEdit";
import {
  PesajeList,
  PesajeListEdit,
  PesajeEdit,
  PesajeCreate,
  PesajeComentarioEdit
} from "./pesajes";
import {
  PesajeMaterialEditableList,
  PesajeMaterialList,
  PesajeMaterialEdit,
  PesajeMaterialCreate
} from "./pesaje-material";
import {
  EtapaCreate,
  EtapaEdit,
  EtapaList,
  EtapaShow,
  EtapasFilter,
  EditableEtapaList
} from "./etapas";
import {
  PredioCreate,
  PredioEdit,
  PredioList
} from "./predios";
import {
  EtapasGrandesGeneradoresList,
  EtapasGrandesGeneradoresEdit,
  EtapasGrandesGeneradoresCreate,
} from "./etapasGrandesGeneradores";
import {
  RemitosList,
  RemitosEdit,
  RemitosCreate,
} from "./remitos";
import {
  EntidadCreate,
  EntidadEdit,
  EntidadList
} from "./entidades";
import {
  IngresoTercerosCreate,
  IngresoTercerosEdit,
  IngresoTercerosList,
} from "./ingresoTerceros";
import {
  IngresoGrandesGeneradoresCreate,
  IngresoGrandesGeneradoresEdit,
  IngresoGrandesGeneradoresList,
} from "./ingresoGrandesGeneradores";
import {
  MaterialCreate,
  MaterialList,
  MaterialEdit,
  MaterialEditableList,
  MaterialShow,
} from "./materiales";
import {
  AuditorCreate,
  AuditorEdit,
  AuditorList,
  EditableAuditorList
} from "./auditores";
import {
  EnfardadorCreate,
  EnfardadorEdit,
  EnfardadorList,
  EditableEnfardadorList,
  EnfardadorShow
} from "./enfardador";
import {
  GrandesGeneradoresCreate,
  GrandesGeneradoresEdit,
  GrandesGeneradoresList
} from "./grandesGeneradores";
import { DashboardRedirect } from "./../components/dashboard/DashboardRedirect";
import { ExportarPesajeCsv } from "./../components/ExportarPesajeCsv/ExportarPesajeCsv";
import { ExportarCartonerosCsv } from "./../components/ExportarCartonerosCsv";

const Administrador = {
  AdministradorCreate,
  AdministradorEdit,
  EditableAdministradorList,
  CartoneroCreate,
  CartoneroEdit,
  CoordinadorCreate,
  CoordinadorEdit,
  EditableCartoneroList,
  EditableCoordinadorList,
  PesadorCreate,
  PesadorEdit,
  PesadorList,
  EditablePesadorList,
  PesadorShow,
  OperacionCreate,
  UserProfileEdit,
  ExportarPesajeCsv,
  EtapaCreate,
  EtapaEdit,
  EtapaList,
  EtapaShow,
  EtapasFilter,
  EditableEtapaList,
  PredioCreate,
  PredioEdit,
  PredioList,
  EtapasGrandesGeneradoresList,
  EtapasGrandesGeneradoresEdit,
  EtapasGrandesGeneradoresCreate,
  EntidadCreate,
  EntidadEdit,
  EntidadList,
  IngresoTercerosCreate,
  IngresoTercerosEdit,
  IngresoTercerosList,
  IngresoGrandesGeneradoresCreate,
  IngresoGrandesGeneradoresEdit,
  IngresoGrandesGeneradoresList,
  RemitosList,
  RemitosEdit,
  RemitosCreate,
  MaterialCreate,
  MaterialList,
  MaterialEdit,
  MaterialEditableList,
  MaterialShow,
  PesajeMaterialEditableList,
  PesajeMaterialCreate,
  PesajeMaterialList,
  PesajeMaterialEdit,
  AuditorCreate,
  AuditorEdit,
  AuditorList,
  EditableAuditorList,
  EnfardadorCreate,
  EnfardadorEdit,
  EnfardadorList,
  EditableEnfardadorList,
  EnfardadorShow,
  ExportarCartonerosCsv,
  GrandesGeneradoresList,
  GrandesGeneradoresCreate,
  GrandesGeneradoresEdit
};

const Cartonero = {
  UserProfileEdit
};

const Auditor = {
  UserProfileEdit
};

const Coordinador = {
  UserProfileEdit,
  CartoneroList,
  CartoneroShow
};

const Pesaje = {
  PesajeList,
  PesajeListEdit,
  PesajeEdit,
  PesajeCreate,
  PesajeComentarioEdit
};

const Pesador = {
  PesajeCreate,
};


const Enfardador = {
  EnfardadorCreate,
  EnfardadorEdit,
  EnfardadorList,
  EditableEnfardadorList,
  EnfardadorShow
};


export {
  Administrador,
  Coordinador,
  Cartonero,
  Pesador,
  Auditor,
  Enfardador,
  DashboardRedirect,
  Pesaje
};



// WEBPACK FOOTER //
// ./src/services/index.js